import Reveal from "./Reveal";
import { careAreas, professional } from "@/config/professional";

export default function CareAreas() {
  return (
    <section id="especialidades" className="bg-background-50 py-16 md:py-28">
      <div className="mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <div className="max-w-2xl">
          <Reveal>
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-primary-600">
              Especialidades
            </p>
            <h2 className="mt-4 font-heading text-4xl font-semibold leading-[1.1] tracking-tight text-foreground-950 md:text-5xl">
              Como posso cuidar de você?
            </h2>
            <p className="mt-5 text-base leading-relaxed text-foreground-600 md:text-lg">
              Cada pessoa chega com uma necessidade diferente. O cuidado também
              precisa ser individual.
            </p>
          </Reveal>
        </div>

        <div className="mt-10 grid gap-px overflow-hidden rounded-lg border border-background-200 bg-background-200 md:grid-cols-2">
          {careAreas.map((area, i) => {
            const external = area.href.startsWith("http");
            return (
              <Reveal key={area.index} delay={i * 70}>
                <article className="group flex h-full flex-col justify-between bg-background-50 p-6 transition-colors duration-300 hover:bg-background-100 md:p-10">
                  <div>
                    <span className="font-heading text-4xl font-medium text-primary-600/25 md:text-5xl">
                      {area.index}
                    </span>
                    <h3 className="mt-3 font-heading text-xl font-semibold text-foreground-950 md:mt-4 md:text-3xl">
                      {area.title}
                    </h3>
                    <p className="mt-3 text-base leading-relaxed text-foreground-600 md:mt-4">
                      {area.copy}
                    </p>
                    {area.note && (
                      <p className="mt-2.5 text-sm leading-relaxed text-foreground-500 md:mt-3">
                        {area.note}
                      </p>
                    )}
                  </div>

                  <a
                    href={area.href}
                    {...(external
                      ? { target: "_blank", rel: "noopener noreferrer" }
                      : {})}
                    className="mt-6 inline-flex items-center gap-2 whitespace-nowrap text-sm font-semibold text-primary-700 transition-colors hover:text-primary-600 md:mt-8"
                  >
                    {area.cta}
                    <i
                      className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"
                      aria-hidden="true"
                    ></i>
                  </a>
                </article>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={120}>
          <p className="mt-8 text-sm leading-relaxed text-foreground-500">
            Todo atendimento começa por uma avaliação individualizada. Converse
            com a profissional para entender a melhor abordagem para o seu caso.
          </p>
        </Reveal>
      </div>
    </section>
  );
}